var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.show)?_c('div',{staticClass:"loading"},[_vm._v("Loading...")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }